import { usePublication } from '../../../../hooks/usePublication';
import { useTrivia } from '../../../../hooks';
import { TriviaReportItem } from './TriviaReportItem';

export const TriviaReport = () => {
  const publication = usePublication();
  const { result } = useTrivia();

  return (
    <table style={{fontFamily: 'Roboto, sans-serif', tableLayout:'fixed', width:'100%'}}>
        <tbody>
            <tr>
                <td style={{ borderBottom: '.1rem solid #e6e6e6', fontSize: '1.5rem', width: '100%'}}>
                    <table style={{background: "url(https://polifoniaeditores.com/vpro2022/libros/public/images/bg_table_results.jpg) no-repeat top center", backgroundSize: "cover", margin: '1rem', padding: '1rem', tableLayout: 'fixed', width: '100%'}}>
                        <tbody>
                            <tr>
                                <td style={{borderBottom: 0, fontSize: '1.5rem', padding: '.5rem 1.5rem', width: '100%'}}>
                                    <table style={{width: '100%'}}>
                                        <tbody>
                                            <tr>
                                                <td style={{backgroundColor:'#fff', borderBottom: 0, fontSize: '1.15rem', padding: '.5rem 1.5rem', width: '100%'}}>Reporte de resultados Trivia: {publication.publication.title}</td>
                                            </tr>
                                            <tr>
                                                <td style={{backgroundColor:'#fff', borderBottom: 0, fontSize: '1.15rem', padding: '.5rem 1.5rem', width: '100%'}}>Fecha: {new Date().toLocaleDateString('es-ES')}</td>
                                            </tr>
                                            <tr>
                                                {/* TODO: Agregar el usuario cuando exista la autenticación */}
                                                {/* <td style={{backgroundColor:'#fff', borderBottom: 0, fontSize: '1.15rem', padding: '.5rem 1.5rem', width: '100%'}}>Usuario: Ferney Rojas</td> */}
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td style={{borderBottom: 0, fontSize: '1.15rem', padding: '.5rem 1.5rem', textAlign: 'center', verticalAlign: 'middle', width: '100%'}}>
                                    <img src="https://polifoniaeditores.com/vpro2022/libros/public/images/vpro_logo.png" alt=""/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            {
                result?.map(question => (
                    <TriviaReportItem key={question.question?.id} question={question}/>
                ))
            }
            <tr>
                <td style={{borderBottom: 0, fontSize: '1.15rem', width: '100%'}}>
                    <table style={{backgroundColor: '#f2f6f7', padding: '1rem 0', width: '100%'}}>
                        <tbody>
                            <tr>
                                <td colSpan={2} style={{borderBottom: 0, fontSize: '1rem', padding: '.5rem 1rem', width: '100%'}}>{publication.publication.title}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} style={{backgroundColor: '#e6e6e6', borderBottom: 0, fontSize: '1rem', padding: '.5rem 1rem', width: '100%'}}>Virtualpro { new Date().getFullYear() }, todos los derechos reservado</td>
                            </tr>
                            <tr>
                                <td style={{borderBottom: 0, fontSize: '1rem', padding: '.5rem 1rem', width: '100%'}}>Descargado el {new Date().toLocaleDateString('es-ES')}</td>
                                {/* <td style={{borderBottom: 0, fontSize: '1rem', padding: '.5rem 1rem', width: '100%'}}>Página 1 de 1</td> */}
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
  )
}